import { appConfig } from '@/config/config'

/**
 * Is this an INTERNAL account — one of ours, rather than a client's?
 *
 * This is not an access check and never was. It only decides which surface to send a
 * signed-in person to: the workspace, or the client portal. A client signs in with their own
 * company's email and is perfectly entitled to be here; they simply belong in the portal.
 *
 * Access itself is the backend's answer. `/me` says whether you are a member and what you
 * may do, `/portal/me` maps your email's domain to a client, and an email that matches
 * neither gets nothing — whatever this function returned.
 */
export function isInternalEmail(email: string | null | undefined): boolean {
  if (!email) return false
  const at = email.lastIndexOf('@')
  if (at === -1) return false
  return email.slice(at + 1).toLowerCase() === appConfig.allowedEmailDomain.toLowerCase()
}
